import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {LocalStorageService, UserService} from '../../_services';
import {ToastService} from '../../_services/toast.service';
import {LoadingService} from '../../_services/loading.service';
import {Location} from '@angular/common';
import {environment} from '../../../environments/environment';

@Component({
  selector: 'app-add-site',
  templateUrl: './add-site.component.html',
  styleUrls: ['./add-site.component.scss']
})
export class AddSiteComponent implements OnInit {
  locationAddress = '';
  postCode = '';
  localGovernmentArea = '';
  websiteAddress = '';
  customCategory = '';
  emailId = '';
  operationTime = '';
  organisationSize = '';
  categoryPlaceholder = 'Write new or select from list';
  viewCategoryModal = false;
  isUserLoggedIn: any;
  categoryList: any[] = [];
  /*categoryList: any[] = [{name: 'Artisanal Products'}, {name: 'Arts & Cultural Centres'},
    {name: 'Communication Organisations'}, {name: 'Creative Spaces'},
    {name: 'Education Providers'}, {name: 'First Nations'},
    {name: 'Galleries'}, {name: 'Historic'}, {name: 'Maker & Co-Working Spaces'},
    {name: 'Museums'}, {name: 'Networks'}, {name: 'Group & Hubs'}, {name: 'Performance Space'},
    {name: 'Performing Arts'}, {name: 'Performing Arts Companies'}, {name: 'Performing Arts Spaces'},
    {name: 'Writing & Publishing'}];*/
  name = '';
  category: Array<string> = [];

  title = '';
  siteId: any;
  coordinates: any = {};

  selectedProject: any;

  constructor(private localStorageService: LocalStorageService,
              private adminService: UserService,
              private spinner: LoadingService,
              private router: Router,
              private location: Location,
              private toast: ToastService,
              private activatedRoute: ActivatedRoute) {
    this.isUserLoggedIn = this.localStorageService.get(environment.currentUser);
    if (this.isUserLoggedIn) {
      this.emailId = this.isUserLoggedIn.user.email;
    }
    this.activatedRoute.queryParams.subscribe((params: any) => {
      if (params.hasOwnProperty('title')) {
        this.title = params.title;
      }
      if (params.hasOwnProperty('lat')) {
        this.coordinates.lat = params.lat;
      }
      if (params.hasOwnProperty('lng')) {
        this.coordinates.lng = params.lng;
      }
    });
    this.selectedProject = this.localStorageService.get('selected_project');
  }

  valueSet(key?: string, value?: string): void {
    console.log(key, value);
    if (key === 'organisationSize') {
      this.organisationSize = value;
    } else {
      this.operationTime = value;
    }
  }

  categorySet(option: any, value: any): void {
    if (option) {
      this.category.push(value);
    } else {
      this.category = this.category.filter((obj: any) => obj !== value);
    }
    this.categoryPlaceholder = this.category.length === 0 ? this.categoryPlaceholder :
      (this.category.length === 1 ? 'Category selected' : 'Multiple categories selected');
  }

  setState(): boolean {
    if (this.selectedProject && this.selectedProject.ref === 'creativePlace') {
      const state = this.name !== '' && this.locationAddress !== '' && this.category.length > 0 && this.postCode !== ''
        && (this.isUserLoggedIn || this.emailId !== '');
      return !state;
    } else {
      const state = this.name !== '' && (this.isUserLoggedIn || this.emailId !== '');
      return !state;
    }
  }

  publishSite() {
    const siteObj: any = {
      // eslint-disable-next-line no-underscore-dangle
      projectId: this.selectedProject._id,
      name: this.name,
      title: this.title,
      locationAddress: this.locationAddress,
      websiteAddress: this.websiteAddress,
      // siteU: this.site,
      category: this.category,
      emailId: this.emailId,
      organisationSize: this.organisationSize,
      operationTime: this.operationTime,
      localGovernmentArea: this.localGovernmentArea,
      postCode: this.postCode,
      location: [this.coordinates.lng, this.coordinates.lat]
    };
    if (this.siteId) {
      Object.assign(siteObj, {siteId: this.siteId});
    }
    this.spinner.show();
    this.adminService.createSite(siteObj)
      .subscribe({
        next: (value: any) => {
          this.spinner.hide();
          this.toast.display('Site created successfully');
          this.router.navigate(['/map']);
        },
        error: (err: any) => {
          this.spinner.hide();
          this.toast.error('Failed to create site');
        }
      });
  }

  ngOnInit(): void {
    this.getCategories();
  }

  getCategories() {
    this.spinner.show();
    // eslint-disable-next-line no-underscore-dangle
    this.adminService.getSiteCategory(this.selectedProject._id)
      .subscribe({
        next: (value) => {
          this.spinner.hide();
          this.categoryList = value;
        },
        error: err => {
          this.spinner.hide();
        }
      });
  }

  back() {
    this.location.back();
  }
}
